<template>
  <div id="app">
    <Navbar></Navbar>
    <ImageViewer @closePopup="closePopup" v-if="showImgeViewer" :imageLink="imageLink"></ImageViewer>
    <div class="row justify-content-around max-width">
      <!-- <i
        @click="RoutBack"
        class="cursor-pointer text-left mt-4 fas col-sm-12 col-md-8 fa-3x fa-arrow-left"
      ></i> -->
      <!-- <button @click="downloadPdf" class="downloadButton mt-4">download report</button> -->
    </div>
    <loader v-if="loaderShow"></loader>
    <div v-if="!loaderShow && Object.keys(data).length">
      <div class="d-flex justify-content-center">
        <button class="downloadButton mt-4 mx-3 capitalize" v-for="(keys, value) in allKeys" :key="value" @click="setPlotType(value)" :class="[plotType == value ? 'activeClass': '']">{{keys}}</button>
      </div>
      <div class="mb-5 pt-5" v-if="Object.keys(data[plotType]).length">
        <div class="row justify-content-around max-width">
          <h5 class="font-size border-bottom capitalize col-11 text-left">{{allKeys[plotType]}}</h5>
        </div>
        <div class="row justify-content-around max-width">
          <div class="col-sm-12 col-md-5"
              v-for="(keys, i) in Object.keys(data[plotType])" :key="i"
          >
            <div style="width: inherit">
              <h3 class="capitalize">{{keys}}</h3>
              <img :src="getBaseData(data[plotType][keys])" class="Image" @click="showImgeViewer=true; imageLink=data[plotType][keys]" style="width: inherit"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div v-if="!loaderShow && Object.keys(data).length">
      <div class="mb-5 pt-5" v-if="data['count_plot'] && Object.keys(data['count_plot']).length">
        <div class="row justify-content-around max-width">
          <h5 class="font-size border-bottom col-8 text-left">Count Plot</h5>
        </div>
        <div
          class="row justify-content-around max-width"
          v-for="(keys, i) in Object.keys(data['count_plot'])"
          :key="i"
        >
          <img :src="data['count_plot'][keys]" class="col-sm-12 Image col-md-10 w-100" />
        </div>
      </div>
      <div class="mb-5 pt-5" v-if="data['corr_plot']">
        <div class="row justify-content-around max-width">
          <h5 class="font-size border-bottom col-8 text-left">Correlation Plot</h5>
        </div>
        <div class="row justify-content-around max-width">
          <img :src="data['corr_plot']" class="col-sm-12 Image col-md-10 w-100" />
        </div>
      </div>
      <div class="my-5 pt-5" v-if=" data['line_plot'] && Object.keys(data['line_plot']).length">
        <div class="row justify-content-around max-width">
          <h5 class="font-size border-bottom col-8 text-left">Line Plot</h5>
        </div>
        <div
          class="row justify-content-around max-width my-4"
          v-for="(keys, i) in Object.keys(data['line_plot'])"
          :key="i"
        >
          <img :src="data['line_plot'][keys]" class="col-sm-12 Image col-md-10 w-100" />
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
// import Swal from 'sweetalert2';
import ImageViewer from "../helper/imageViewer";
import Toasted from "vue-toasted";
import Vue from "vue";
// import $ from "jquery";
// import moment from "moment";
// import { AUTH_LOGOUT } from '../store/actions/auth'
import { apiCall } from "@/utils/api";
import loader from "../loader";
import Navbar from "../navbar";

Vue.use(Toasted);

export default {
  name: "Graph",
  components: {
    ImageViewer: ImageViewer,
    loader: loader,
    Navbar: Navbar
  },
  data() {
    return {
      imageLink: '',
      showImgeViewer: false,
      allKeys: {},
      plotType: "",
      loaderShow: true,
      visualId: "",
      data: {}
    };
  },
  watch: {},
  mounted() {
    this.visualId = this.$route.params.id;
    this.getData(this.visualId);
  },
  computed: {},
  methods: {
    getBaseData(Base64) {
      return `data:image/png;base64, ${Base64}`
    },
    closePopup() {
      this.showImgeViewer = false
    },
    setPlotType(value) {
      this.plotType = value
    },
        downloadPdf() {
      let printContents, popupWin;
      printContents = document.getElementById("app").innerHTML;
      popupWin = window.open(
        "",
        "_blank",
        "top=0,left=0,height=100%,width=auto"
      );
      popupWin.document.open();
      popupWin.document.write(`
          <html>
            <head>
            <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
            </head>
            <style>
            @media print {
              .downloadButton {
                display: none;
              }
              .Image {page-break-inside: avoid;}
            }
            </style>
        <body onload="window.print();window.close()">${printContents}</body>
          </html>`);
      popupWin.document.close();
    },
    RoutBack() {
      this.$router.push("/visualize");
    },
    getData(id) {
      var ths = this;
      const url = `visual_ml/graph/${id}`;
      apiCall({ url, method: "get" })
        .then(resp => {
            let allKeys = Object.keys(resp)
            ths.plotType = allKeys[0]
            allKeys.map((key)=> {
              ths.allKeys[key] = key.replace('_', ' ')
            })
            if (!Object.keys(resp).length) {
              ths.loaderShow = false;
            } else {
              ths.data = resp;
              ths.loaderShow = false;
            }
          // console.log('resp is her/e', resp)
          // let allKeys = Object.keys(JSON.parse(resp.data))
          // ths.plotType = allKeys[0]
          // allKeys.map((key) => {
          //   ths.allKeys[key] = key.replace('_', ' ')
          // })
          // if (!Object.keys(resp.data).length) {
          //   ths.loaderShow = false;
          // } else {
          //   ths.data = JSON.parse(resp.data);
          //   ths.loaderShow = false;
          // }
          // console.log('response is here', JSON.parse(resp.data))
          // // const fileUrl = resp.data[0]["graph"].url;
          // $.ajax({
          //   async: true,
          //   url: fileUrl,
          //   type: "GET",
          //   jsonp: "jsonp",
          //   crossDomain: true,
          //   dataType: "json",
          //   headers: {
          //     "cache-control": "no-cache"
          //   },
          //   success: function(data) {
          //     let allKeys = Object.keys(data)
          //     ths.plotType = allKeys[0]
          //     allKeys.map((key)=> {
          //       ths.allKeys[key] = key.replace('_', ' ')
          //     })
          //     if (!Object.keys(data).length) {
          //       ths.loaderShow = false;
          //     } else {
          //       ths.data = data;
          //       ths.loaderShow = false;
          //     }
          //   },
          //   error: function(err) {
          //     ths.loaderShow = false;
          //     console.log("Uh Oh!", err);
          //   }
          // });
        })
        .catch(err => {
          console.log("error", err);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.downloadButton {
  width: 9rem;
  height: 3rem;
  border: none;
  color: white;
  background: cadetblue;
  border-radius: 20px;
}
.cursor-pointer {
  cursor: pointer;
}
.font-size {
  font-size: 2.5rem;
}
.max-width {
  max-width: 100vw !important;
}
.scrollb::-webkit-scrollbar {
  display: none;
}
.widthH {
  width: 36% !important;
}
.cursor-pointer {
  cursor: pointer;
}
.line-height {
  line-height: 2rem;
}
.widthCorelation {
  width: 50%;
}
.capitalize {
  text-transform: capitalize;
}
.activeClass {
  background: white;
  color: #5e9ea0;
  border: 1px solid #5e9ea0;
}
img {
    page-break-before: auto; /* 'always,' 'avoid,' 'left,' 'inherit,' or 'right' */
    page-break-after: auto; /* 'always,' 'avoid,' 'left,' 'inherit,' or 'right' */
    page-break-inside: avoid; /* or 'auto' */
}
</style>
